import React, { useEffect, useState, useMemo } from 'react'
import WebMain from './WebMain'
import { useSearchParams } from 'react-router-dom'
import { Select } from 'antd'
import { useYhUpdateQuery } from '../store/BnsKeJiApi'
import FrontSketchDesc from './FrontSketchDesc'
import { useNavigate } from 'react-router-dom'
import { h5SketchProject } from './h5Routes'

function FrontSketchClient() {
    const [param] = useSearchParams()
    const yh_id = param.get('yh_id')
    const yh_name = param.get('yh_name')
    const bxm_id = param.get('bxm_id')
    const bxm_name = param.get('bxm_name')
    const [rightMenu, setRightMenu] = useState([])
    const { data: rightMenuData, isSuccess: rightMenuSuccess } = useYhUpdateQuery({ yh_id }, { skip: !yh_id })

    useEffect(() => {
        if (rightMenuSuccess) {
            if (rightMenuData.Status === 'success') {
                const extractNumberFromText = (text) => {
                    const match = text.match(/\d+/)
                    return match ? parseInt(match[0], 10) : 0
                }
                const sortMenuByNumbers = (menuItems) =>
                    [...menuItems].sort((a, b) => extractNumberFromText(a.bxmxq_name || '') - extractNumberFromText(b.bxmxq_name || ''))
                const sortChildrenByNumbers = (children) =>
                    [...children].sort((a, b) => extractNumberFromText(a.bxmbb_name || '') - extractNumberFromText(b.bxmbb_name || ''))

                const sortedChildren = sortMenuByNumbers(rightMenuData.Result.children || [])
                const arr = sortedChildren.map((item) => {
                    const { bxmxq_id, bxmxq_name, children } = item
                    const sortedSubChildren = children ? sortChildrenByNumbers(children) : []
                    return {
                        key: `parent_${bxmxq_id}`,
                        label: bxmxq_name,
                        children: sortedSubChildren.map((child) => ({
                            key: `child_${child.bxmbb_id}`,
                            label: child.bxmbb_name,
                        })),
                    }
                })
                setRightMenu(arr)
            }
        }
    }, [rightMenuData, rightMenuSuccess])

    const selectOptions = useMemo(() => {
        const opts = []
        rightMenu.forEach((parent) => {
            ;(parent.children || []).forEach((child) => {
                opts.push({
                    value: child.key,
                    label: `${parent.label} / ${child.label}`,
                    parentKey: parent.key,
                    parentLabel: parent.label,
                })
            })
        })
        return opts
    }, [rightMenu])

    const [bxmxq_id, setBxmxq_id] = useState('')
    const [currentMenuData, setCurrentMenuData] = useState(null)
    const [sectionLabel, setSectionLabel] = useState('')

    useEffect(() => {
        if (rightMenuSuccess && rightMenu && rightMenu.length > 0) {
            const firstMenuWithChildren = rightMenu.find((menu) => menu.children && menu.children.length > 0)
            if (firstMenuWithChildren && firstMenuWithChildren.children.length > 0) {
                const firstChild = firstMenuWithChildren.children[0]
                setBxmxq_id(firstChild.key)
                setSectionLabel(firstMenuWithChildren.label)
            } else {
                setBxmxq_id(rightMenu[0].key)
                setSectionLabel(rightMenu[0].label)
            }
        }
    }, [rightMenu, rightMenuSuccess])

    useEffect(() => {
        if (rightMenuSuccess && rightMenuData && rightMenuData.Status === 'success' && bxmxq_id) {
            const originalBxmbbId = bxmxq_id.replace('child_', '')
            const findMenuDataItem = (children, targetId) => {
                for (const item of children) {
                    if (item.children) {
                        for (const child of item.children) {
                            if (String(child.bxmbb_id) === String(targetId)) {
                                return child
                            }
                        }
                    }
                }
                return null
            }
            const menuDataItem = findMenuDataItem(rightMenuData.Result.children, originalBxmbbId)
            setCurrentMenuData(menuDataItem)
        }
    }, [rightMenuSuccess, rightMenuData, bxmxq_id])

    const navigate = useNavigate()

    return (
        <WebMain>
            <div style={{ width: '100%', padding: '0 12px 24px' }}>
                <span
                    role="link"
                    tabIndex={0}
                    onClick={() => navigate(h5SketchProject(bxm_id))}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navigate(h5SketchProject(bxm_id))
                    }}
                    style={{ textAlign: 'center', color: '#fff', fontSize: 18, fontWeight: 'bold', display: 'block' }}
                >
                    {bxm_name}
                </span>
                <Select
                    style={{ width: '100%', marginTop: 12 }}
                    placeholder="选择功能模块"
                    options={selectOptions.map((o) => ({ value: o.value, label: o.label }))}
                    value={bxmxq_id || undefined}
                    onChange={(v) => {
                        const opt = selectOptions.find((o) => o.value === v)
                        setBxmxq_id(v)
                        if (opt) {
                            setSectionLabel(opt.parentLabel)
                        }
                    }}
                    showSearch
                    optionFilterProp="label"
                />
                <div
                    style={{
                        backgroundColor: '#fff',
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 12,
                    }}
                >
                    {bxmxq_id ? (
                        <FrontSketchDesc
                            data={currentMenuData}
                            bxm_id={bxm_id}
                            yh_name={yh_name}
                            bxmxq_name={sectionLabel}
                            bxmbb_name={currentMenuData?.bxmbb_name || ''}
                            bxm_name={bxm_name}
                            yh_id={yh_id}
                        />
                    ) : (
                        <div
                            style={{
                                textAlign: 'center',
                                padding: '48px 16px',
                                color: '#999',
                                fontSize: 15,
                            }}
                        >
                            <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
                            <div>请从上方下拉框选择功能模块查看详情</div>
                        </div>
                    )}
                </div>
            </div>
        </WebMain>
    )
}

export default FrontSketchClient
